import React from 'react';
import MapWithAMarker from './MapWithAMarker';

const GoogleMap = ({
  latitude = 9.065,
  longitude = 7.388,
  mapHeight = 200,
  setValue,
  data,
  field,
  ...restProps
}) => {
  return (
    <MapWithAMarker
      googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.31&amp;key=AIzaSyD9RfNQp6NGKrEtVqcc19JlgTOohV83sF8&amp;libraries=places,geometry&amp;"
      lat={latitude}
      lng={longitude}
      loadingElement={<div style={{ height: mapHeight }} />}
      containerElement={<div style={{ height: mapHeight }} />}
      mapElement={<div style={{ height: mapHeight }} />}
      onClick={(e) => {
        let lat = e.latLng.lat();
        let lon = e.latLng.lng();
        setValue({ data, field, value: { lat, lon } });
      }}
    />
  );
};

export default GoogleMap;
